module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', [_c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "10em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 sp-padding-top-10 sp-padding-bottom-100"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "prd-custom-header"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": '/' + _vm.product.product_business_ownername
    }
  }, [_vm._v("@" + _vm._s(_vm.product.product_business_ownername))])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "clear": "right"
    }
  }, [_vm._v(_vm._s(_vm.product.product_name))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-6 padding-bottom-100"
  }, [_c('div', {
    staticClass: "prd-images-slider"
  }, [_c('img', {
    staticClass: "sp-prd-img-cover img-responsive",
    attrs: {
      "src": _vm.img_product_url + _vm.product_item.product_item_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("Items in this product")]), _vm._v(" "), (_vm.edit_mode) ? _c('p', [_vm._v("add other variations like colors, sizes etc")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.product.product_items), function(pt) {
    return _c('div', {
      staticClass: "col-md-4 col-sm-12 image-thumbnail"
    }, [_c('div', {
      staticClass: "inner-img"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('set-product-item', pt)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.img_product_url + pt.product_item_image,
        "alt": ""
      }
    })])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.seller_mode) ? _c('div', {}, [(!_vm.addProductItemPanel) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-product-item', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Item")]) : _c('div', [_c('div', [_c('product-item-form')], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card col-md-5"
  }, [(_vm.edit_mode) ? _c('div', [(_vm.editProductPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Product")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Product Name\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_name),
      expression: "product.product_name"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Category:- " + _vm._s(_vm.product.product_category_name) + " ")]), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_category),
      expression: "product.product_category"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.product.product_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.product.product_category_id
    }
  }, [_vm._v(_vm._s(_vm.product.product_category_name))]), _vm._v(" "), _vm._l((_vm.sellpoint_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.business_category_id
      }
    }, [_vm._v(_vm._s(category.business_category))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Description\r\n                                            "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_description),
      expression: "product.product_description"
    }],
    domProps: {
      "value": (_vm.product.product_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProduct
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])])])])]) : _c('button', {
    staticClass: "btn btn-xs pull-left col-sm-8",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product', '')
      }
    }
  }, [_vm._v("Edit Description")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("Sold by: "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.redir(_vm.product.product_business_ownername)
      }
    }
  }, [_vm._v(_vm._s(_vm.product.product_business_ownername))]), _vm._v(" under "), _c('b', [_vm._v(_vm._s(_vm.product.product_category_name))])]), _vm._v(" "), (_vm.product_item.product_item_actual_price != 0) ? _c('span', {
    staticClass: "price"
  }, [_c('del', [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_actual_price))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(_vm.product_item.product_item_price))]), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.editProductItemPanel) ? _c('div', {
    staticClass: "col-sm-12 contact_form",
    attrs: {
      "id": "editProductItem"
    }
  }, [_c('h6', [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Product Item Image")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_product_url + _vm.product_item.product_item_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Change Product Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_image')
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Price\r\n                                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_price),
      expression: "product_item.product_item_price"
    }],
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Weight\r\n                                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_weight),
      expression: "product_item.product_item_weight"
    }],
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_weight = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Product Item Quantity\r\n                                              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_quantity),
      expression: "product_item.product_item_quantity"
    }],
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product_item.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductItem
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn col-md-4",
    staticStyle: {
      "line-height": "1.2",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "icon-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br')])])]) : _c('div', [_c('a', {
    staticClass: "pull-right",
    staticStyle: {
      "cursor": "pointer",
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-product-item', '')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pull-right",
    staticStyle: {
      "cursor": "pointer",
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-product-item', '')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), (_vm.removeItemPanel) ? _c('span', {
    staticClass: "pull-left col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeProductItem
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.product_item.product_item_total_discount != 0) ? _c('div', {
    staticClass: "on-sale"
  }, [_vm._v(" \r\n                        " + _vm._s(_vm.product_item.product_item_total_discount) + "% "), _c('span', [_vm._v("OFF")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('div', {
    staticClass: "some-info"
  }, [(_vm.is_product_in_cart) ? _c('div', {
    staticStyle: {
      "border": "dotted 1px #96c5f5",
      "padding": "5px 2px"
    }
  }, [_c('p', [_vm._v("This Item is in your cart \r\n                            "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "width": "12em",
      "cursor": "pointer",
      "line-height": "1.8"
    },
    on: {
      "click": function($event) {
        _vm.redir('cart')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" View Cart")])])]) : _c('div', [(!_vm.edit_mode) ? _c('ul', {
    staticClass: "col-xs-12 row margin-top-30"
  }, [_c('li', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "quinty"
  }, [_vm._v(" \r\n                                Quantity: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_item.product_item_order_quantity),
      expression: "product_item.product_item_order_quantity"
    }],
    staticStyle: {
      "max-width": "52px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.product_item.product_item_order_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product_item.product_item_order_quantity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('add-to-cart-button', {
    attrs: {
      "productMain": _vm.product,
      "productItem": _vm.product_item
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-info",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', [_c('h6', [_vm._v("DELIVERY & RETURNS INFORMATION")]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [(_vm.product.product_delivery_returns != ' ') ? _c('div', [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.product.product_delivery_returns) + " ")]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Please note that Returns, Shipping and Delivery are handled independently by the seller.\r\n                                Sellpoint only provides a conducive platform for both sellers and buyers, we also recommend reliable shipping \r\n                                partners to make transactions seamless.\r\n                              ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), (((_vm.product.product_delivery_options != 0) || (_vm.product.product_business_delivery_options.length != 0))) ? _c('div', [_c('h6', [_vm._v("PRODUCT DELIVERY LOCATIONS")]), _vm._v("vv" + _vm._s(_vm.product.product_business_delivery_options) + "\r\n                            "), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticClass: "tiny-notice",
    staticStyle: {
      "border": "solid 1px #eeddcc",
      "padding": "1em",
      "background": "#fcf7f3"
    }
  }, [_c('div', [(((_vm.product.product_delivery_options) && (_vm.product.product_delivery_options.length != 0))) ? _c('div', _vm._l((_vm.product.product_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - " + _vm._s(delivery.business_delivery_option_price) + "\r\n                                  ")])
  })) : _c('div', _vm._l((_vm.product.product_business_delivery_options), function(delivery) {
    return _c('li', [_c('b', [_vm._v(_vm._s(delivery.business_delivery_option))]), _vm._v(" - " + _vm._s(delivery.business_delivery_option_price * _vm.product_item.product_item_weight * 1) + " ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("SHARE THIS PRODUCT")]), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card item-decribe"
  }, [_c('ul', {
    staticClass: "nav nav-tabs animate fadeInUp"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-descr', '')
      }
    }
  }, [_vm._v("DESCRIPTION")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-reviews', '')
      }
    }
  }, [_vm._v("COMMENTS & REVIEWS")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('set-information', '')
      }
    }
  }, [_vm._v("MORE INFORMATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content animate fadeInUp details-box"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product_details_reviews) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [(_vm.product.product_reviews) ? _c('h6', [_vm._v(_vm._s(_vm.product.product_reviews.length) + " COMMENTS AND REVIEWS")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.product.product_reviews), function(review) {
    return _c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": _vm.img_user_url + review.product_reviewed_by_image,
        "alt": ""
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h6', [_vm._v(_vm._s(review.product_reviewed_by)), _c('span', {
      staticClass: "pull-right"
    })]), _vm._v(" "), _c('p', {
      staticClass: "font-playfair"
    }, [_vm._v(_vm._s(review.product_review))]), _vm._v(" "), _c('h6', [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(review.product_review_date))])])])])
  }), _vm._v(" "), (!_vm.edit_mode) ? _c('div', [_c('h6', {
    staticClass: "margin-t-40"
  }, [_vm._v("ADD COMMENT/REVIEW")]), _vm._v(" "), _c('form', [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *YOUR REVIEW\r\n                                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reviews.review),
      expression: "reviews.review"
    }],
    domProps: {
      "value": (_vm.reviews.review)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reviews.review = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-dark btn-small pull-right no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addProductReview
    }
  }, [_vm._v("POST")])])])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_information) ? _c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_vm._l((_vm.product.product_information), function(info) {
    return _c('div', {}, [(info.product_info_type == 'image') ? _c('div', [_c('p', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.img_product_url + info.product_info_detail,
        "alt": ""
      }
    })])]) : _vm._e(), _vm._v(" "), (info.product_info_type == 'text') ? _c('div', [_c('p', [_vm._v(_vm._s(info.product_info_detail))]), _vm._v(" "), _c('hr')]) : _vm._e()])
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.information.product_info_detail),
      expression: "information.product_info_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product information"
    },
    domProps: {
      "value": (_vm.information.product_info_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.information.product_info_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductInformation
    }
  }, [_vm._v("Add to Product Information")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add an Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, 'product_information', _vm.product.product_id)
      }
    }
  })])])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.product_details_descr) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.product_description))]), _vm._v(" "), _c('h6', [_vm._v("MORE DETAILS")]), _vm._v(" "), _c('ul', _vm._l((_vm.product.product_details), function(details) {
    return _c('li', [(_vm.edit_mode) ? _c('div', [(details.edit_product_detail) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (details.product_detail),
        expression: "details.product_detail"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (details.product_detail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          details.product_detail = $event.target.value
        }
      }
    }), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": _vm.editProductDetail
      }
    }, [_c('i', {
      staticClass: "icon-check"
    })])]) : _c('p', [_vm._v(_vm._s(details.product_detail) + "\r\n                                "), (_vm.edit_mode) ? _c('span', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('edit-product-detail', details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-edit"
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "btn"
      },
      on: {
        "click": function($event) {
          _vm.deleteProductDetail(details)
        }
      }
    }, [_c('i', {
      staticClass: "icon-trash"
    })])]) : _vm._e()])]) : _c('p', [_vm._v(_vm._s(details.product_detail))])])
  })), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('br'), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.details.new_product_detail),
      expression: "details.new_product_detail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter new product detail"
    },
    domProps: {
      "value": (_vm.details.new_product_detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.details.new_product_detail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "line-height": "1.6",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addProductDetail
    }
  }, [_vm._v("Add to Details")])])]) : _vm._e()]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.other_products), function(o_product, prdex) {
    return _c('div', {
      staticClass: "post-content"
    }, [(_vm.product.product_id != o_product.product_id) ? _c('div', [_c('div', {
      staticClass: "profile-top",
      staticStyle: {
        "background": "#ffffff"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "href": '/' + _vm.product.product_business_ownername
      }
    }, [_c('span', {}, [_c('img', {
      staticClass: "profile-photo-md pull-left",
      staticStyle: {
        "border-radius": "50%",
        "border": "2px solid #f4f4f4",
        "width": "35px",
        "height": "35px"
      },
      attrs: {
        "src": o_product.product_business_brand_image
      }
    })]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "padding-left": "3em",
        "padding-top": "5px",
        "font-size": "18px",
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(o_product.product_business_name)), _c('span', {
      staticClass: "following"
    }, [_vm._v("@" + _vm._s(o_product.product_business_ownername))]), _vm._v(" "), _vm._m(6, true)])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), (o_product.product_items && (o_product.product_items.length == 1)) ? _c('div', _vm._l((o_product.product_items), function(product_item, index) {
      return _c('div', [_c('div', {
        staticClass: "col-md-12"
      }, [_c('div', {
        staticClass: "ribbon ribbon-top-left"
      }, [_c('span', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))])]), _vm._v(" "), _c('a', {
        attrs: {
          "href": '/' + o_product.product_business_ownername + '/' + o_product.product_url_name
        }
      }, [_c('img', {
        staticClass: "img-responsive post-image",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": "post-image"
        }
      })])])])
    })) : _c('div', {
      staticClass: "col-container"
    }, _vm._l((o_product.product_items), function(product_item, index) {
      return _c('div', {
        attrs: {
          "classs": "col-md-12"
        }
      }, [(index == 0) ? _c('div', {
        staticClass: "col col-md-8 pleft"
      }, [_c('div', {
        staticClass: "ribbon ribbon-top-left"
      }, [_c('span', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))])]), _vm._v(" "), _c('a', {
        attrs: {
          "href": '/' + o_product.product_business_ownername + '/' + o_product.product_url_name
        }
      }, [_c('img', {
        staticClass: "img-responsive post-image",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": "post-image"
        }
      })])]) : _c('div', {
        staticClass: "col col-md-4 pright"
      }, [_c('div', {
        staticClass: "ribbon ribbon-top-left"
      }, [_c('span', [_vm._v("₦" + _vm._s(product_item.product_item_price.toLocaleString('en', {
        useGrouping: true
      })))])]), _vm._v(" "), _c('a', {
        attrs: {
          "href": '/' + o_product.product_business_ownername + '/' + o_product.product_url_name
        }
      }, [_c('img', {
        staticClass: "img-responsive post-image",
        attrs: {
          "src": _vm.img_product_url + product_item.product_item_image,
          "alt": "post-image"
        }
      })])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "post-container"
    }, [_c('img', {
      staticClass: "profile-photo-md pull-left",
      attrs: {
        "src": o_product.product_business_brand_image,
        "alt": "user"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "post-detail"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('h5', [_c('a', {
      staticClass: "profile-link",
      staticStyle: {
        "font-size": "22px"
      },
      attrs: {
        "href": '/' + o_product.product_business_ownername + '/' + o_product.product_url_name
      }
    }, [_vm._v(_vm._s(o_product.product_name))]), _vm._v(" "), _c('span', {
      staticClass: "following"
    }, [_vm._v(_vm._s(o_product.product_category_name))])]), _vm._v(" "), _vm._m(7, true)]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "line-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "post-text"
    }, [_c('p', [_vm._v(_vm._s(o_product.product_description) + " \r\n                          ")])]), _vm._v(" "), _c('div', {
      staticClass: "line-divider"
    }), _vm._v(" "), _vm._m(9, true)])])]) : _vm._e()])
  })], 2), _vm._v(" "), _vm._m(10)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Edit this Item "), _c('i', {
    staticClass: "fa fa-pencil"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Remove this Item "), _c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "social_icons",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "stars"
  }, [_c('span', [_vm._v("YOUR RATING")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  }), _c('i', {
    staticClass: "fa fa-star"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 static"
  }, [_c('div', {
    attrs: {
      "id": "sticky-feeds"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Ongoing Activities")]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("sellpoint.business_name")]), _vm._v(" Commended on a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("5 mins ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "feed-item"
  }, [_c('div', {
    staticClass: "live-activity"
  }, [_c('p', [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _c('a', {
    staticClass: "profile-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("sellpoint.business_name")]), _vm._v(" Has posted a product")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("an hour ago")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tradefair Talks")]), _vm._v(" "), _c('ul', {
    staticClass: "online-users list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Linda Lohan"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sophia Lee"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "John Doe"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Alexis Clark"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "James Carter"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Robert Cook"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Richard Bell"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Anna Young"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Julia Cox"
    }
  }, [_c('img', {
    staticClass: "img-responsive profile-photo",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": "user"
    }
  }), _c('span', {
    staticClass: "online-dot"
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("I ALSO HAVE THESE")]), _vm._v(" "), _c('span', [_vm._v("Check out other products found in my sellpoint")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "14px",
      "background": "#fa4343",
      "padding": "8px",
      "color": "#ffffff"
    }
  }, [_vm._v("10% "), _c('br'), _vm._v("Off\r\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("#productautohashtag"), _c('span', {
    staticClass: "likes-total"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reaction"
  }, [_c('a', {
    staticClass: "btn text-red"
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    staticStyle: {
      "font-size": "24px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-comment"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "write a review or comment"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 static"
  }, [_c('div', {
    staticClass: "suggestions",
    attrs: {
      "id": "sticky-sidebar"
    }
  }, [_c('h4', {
    staticClass: "grey"
  }, [_vm._v("Suggested for you")]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Simi Shapers")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Chris Foodstore")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Olafumi Jewellries")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Trish Hairs")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])]), _vm._v(" "), _c('div', {
    staticClass: "follow-user"
  }, [_c('img', {
    staticClass: "profile-photo-sm pull-left",
    attrs: {
      "src": "http://placehold.it/300x300",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('h5', [_c('a', {
    attrs: {
      "href": "timeline#"
    }
  }, [_vm._v("Nina Organics")])]), _vm._v(" "), _c('a', {
    staticClass: "text-green",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Follow Shop")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a9ae026"}!./src/pages/Sellpoint/Product/template.html
// module id = 257
// module chunks = 0